import { MAX_END_DATE } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useMaxEndDate() {
  return useIsFeatureEnabled(MAX_END_DATE);
}
